import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Calculate } from "@mui/icons-material";

export default function CalculateWaterElevationButton({
  landSurfaceElevation,
  measuringPoint,
  waterLevelDepth,
  onCalculate,
}) {
  // Convert to numbers if they're strings
  const landSurfaceNum =
    typeof landSurfaceElevation === "string"
      ? parseFloat(landSurfaceElevation)
      : landSurfaceElevation;
  const measuringPointNum =
    typeof measuringPoint === "string"
      ? parseFloat(measuringPoint)
      : measuringPoint;
  const waterLevelDepthNum =
    typeof waterLevelDepth === "string"
      ? parseFloat(waterLevelDepth)
      : waterLevelDepth;

  // Check if all required values are available and valid
  const isAvailable =
    landSurfaceNum != null &&
    !isNaN(landSurfaceNum) &&
    measuringPointNum != null &&
    !isNaN(measuringPointNum) &&
    waterLevelDepthNum != null &&
    !isNaN(waterLevelDepthNum);

  const handleClick = () => {
    if (!isAvailable) return;

    // Formula: Water Elevation = Land Surface Elevation + Measuring Point - Water Level Depth
    const waterElevation =
      landSurfaceNum + measuringPointNum - waterLevelDepthNum;

    // Round to 1 decimal place
    const rounded = Math.round(waterElevation * 10) / 10;
    onCalculate?.(rounded);
  };

  const getTooltipText = () => {
    if (landSurfaceNum == null || isNaN(landSurfaceNum)) {
      return "Land surface elevation required";
    }
    if (measuringPointNum == null || isNaN(measuringPointNum)) {
      return "Measuring point required";
    }
    if (waterLevelDepthNum == null || isNaN(waterLevelDepthNum)) {
      return "Water level depth required";
    }
    return "Calculate water elevation";
  };

  return (
    <Tooltip title={getTooltipText()}>
      <span>
        <IconButton
          edge="end"
          size="small"
          color="secondary"
          onClick={handleClick}
          disabled={!isAvailable}
          sx={{
            border: "1px solid",
            borderColor: (theme) =>
              isAvailable ? theme.palette.primary.main : "transparent",
            borderRadius: 1,
            padding: "4px",
            backgroundColor: "transparent",
            "&:hover": {
              backgroundColor: (theme) => theme.palette.action.hover,
            },
          }}
        >
          <Calculate />
        </IconButton>
      </span>
    </Tooltip>
  );
}
